import { render, staticRenderFns } from "./AssignPowerOfAttorney.vue?vue&type=template&id=45a9d9d6&"
import script from "./AssignPowerOfAttorney.vue?vue&type=script&lang=js&"
export * from "./AssignPowerOfAttorney.vue?vue&type=script&lang=js&"
import style0 from "./AssignPowerOfAttorney.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports